<template>
   <div class="createPop">
      <div class="popBox">
        <p class="popTitle">
          <span class="title1">{{ $t("global.添加到频道") }}</span
          ><img
            class="close"
            @click="close"
            src="/static/close_btn@2x.png"
            alt=""
          />
        </p>
        <div class="from1">
          <div class="searsh">
          </div>
          <div class="nameBox" v-for="(item, i) in createList" :key="i">
            <div class="selectBox" @click="selectLook(item)">
              <img
                v-if="item.isFollow"
                src="/static/uploadvideo/icon_upload_multi_selected@2x.png"
                alt=""
              /><span v-else class="textBox"></span>

              <span class="textTi">{{ item.title }}</span>
            </div>
          </div>
        </div>
        <div class="buttom1 clearfix">
          <div class="subButBox">
            <span class="subcel" @click="close">{{
              $t("collect.取消")
            }}</span
            ><span
              class="subcir"
              @click="saveLook"
              >{{ $t("collect.确定") }}</span
            >
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "subjectDialog",
  props: ["videoId"],
  data() {
    return {
      createList: []
    };
  },
  created() {
    this.getTopicList()
  },
  methods: {
    selectLook(item) {
      if (item.isFollow) {
        item.isFollow = !item.isFollow;
      } else {
        item.isFollow = true;
      }
    },
    close() {
        this.$emit("hiddendialog")
    },
    saveLook() {

    },
    getTopicList() {
      let params = {
        orderByType: 0,
        pageIndex: 1,
        pageSize: 20
      }
      this.$http.get("/api/topic/findList", {params}).then((res)=>{
        this.createList = res.data.list;
      })
    }
  },
  watch: {

  }
};
</script>

<style lang="stylus" scoped>
.createPop {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;

  .popBox {
    width: 445px;
    height: 362px;
    background: rgba(255, 255, 255, 1);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .titleText {
      height: 60px;
      line-height: 60px;
      padding-left: 24px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      position: relative;
      border-bottom: 1px solid #E0E0E0;

      .close {
        position: absolute;
        right: 24px;
        top: 23px;
        width: 13px;
        height: 13px;
      }
    }

    .from {
      padding: 20px 24px 0;

      .name {
        font-size: 15px;
        font-weight: 600;
        color: #333;

        i {
          color: #FE5630;
        }
      }

      .text {
        width: 100%;
        height: 40px;
        margin: 12px 0 20px 0;
        position: relative;

        input {
          display: inline-block;
          width: 100%;
          height: 40px;
          border: 1px solid #E0E0E0;
          padding: 0 50px 0 15px;
          box-sizing: border-box;

          &:focus {
            border: 1px solid #2026CC;
          }
        }

        .numLen {
          position: absolute;
          font-size: 14px;
          font-weight: 400;
          color: #E0E0E0;
          right: 10px;
          height: 21px;
          top: 10px;
          line-height: 21px;
        }
      }

      .select {
        margin-top: 15px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;

        .left {
          float: left;
          margin-right: 30px;
          cursor: pointer;
        }

        .right {
          float: left;
          cursor: pointer;
        }

        .circular {
          display: inline-block;
          width: 20px;
          height: 20px;
          border: 1px solid #B8B8B8;
          border-radius: 50%;
          vertical-align: middle;
          margin-right: 10px;
          position: relative;

          .isSele {
            position: absolute;
            width: 10px;
            height: 10px;
            background: #2026cc;
            border-radius: 50%;
            left: 50%;
            top: 50%;
            -webkit-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
          }
        }

        .cirColor {
          border: 1px solid #2026CC;
        }
      }
    }

    .buttom {
      margin-top: 60px;
      text-align: center;

      .cel {
        width: 90px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #999999;
        display: inline-block;
        margin-right: 20px;
        box-sizing: border-box;
        vertical-align: middle;
        font-size: 14px;
        font-weight: 600;
        color: #333333;
        cursor: pointer;
      }

      .cir {
        display: inline-block;
        width: 90px;
        height: 30px;
        line-height: 30px;
        background: #2026CC;
        vertical-align: middle;
        font-size: 14px;
        font-weight: 600;
        color: #FFFFFF;
        cursor: pointer;
      }
    }

    .popTitle {
      height: 60px;
      line-height: 60px;
      padding-left: 24px;
      box-sizing: border-box;
      position: relative;
      border-bottom: 1px solid #E0E0E0;

      .title1 {
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        margin-right: 16px;
      }

      .title2 {
        font-size: 12px;
        font-weight: 400;
        color: rgba(32, 38, 204, 0.85);
        cursor: pointer;

        .infoIcon {
          width: 14px;
          height: 14px;
          margin-right: 4px;
          margin-bottom: 2px;
        }
      }

      .close {
        position: absolute;
        right: 24px;
        top: 23px;
        width: 13px;
        height: 13px;
      }
    }

    .from1 {
      padding: 20px 24px 0;
      height: 230px;
      box-sizing: border-box;
      overflow-y: scroll;

      .nameBox {
        margin-bottom: 16px;
        cursor: pointer;
        font-size: 15px;
        font-weight: 400;
        color: #333333;
        position: relative;

        .selectBox {
          display: inline-block;
        }

        img {
          width: 18px;
          height: 18px;
          margin-right: 10px;
        }

        .textTi {
          display: inline-block;
          max-width: 320px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          vertical-align: middle;
        }

        .textBox {
          display: inline-block;
          width: 18px;
          height: 18px;
          border: 2px solid #B8B8B8;
          box-sizing: border-box;
          vertical-align: middle;
          margin-right: 10px;
        }

        .privateIcon {
          width: 16px;
          height: 16px;
          margin-right: 0;
        }
      }
    }

    .buttom1 {
      border-top: 1px solid #E0E0E0;
      height: 70px;
      padding: 20px 24px;
      box-sizing: border-box;

      .subButBox {
        text-align: center;

        .subcel {
          width: 90px;
          height: 30px;
          border: 1px solid #999999;
          box-sizing: border-box;
          line-height: 30px;
          font-size: 14px;
          font-weight: 600;
          color: #333333;
          display: inline-block;
          text-align: center;
          vertical-align: middle;
          margin-right: 20px;
          cursor: pointer;
        }

        .subcir {
          width: 90px;
          height: 30px;
          background: #2026CC;
          line-height: 30px;
          font-size: 14px;
          font-weight: 600;
          color: #FFFFFF;
          display: inline-block;
          text-align: center;
          vertical-align: middle;
          cursor: pointer;
        }

        .colorCir {
          background: #E0E0E0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subjectDialog.vue